import React from 'react';
import './index.css';

const Loading: React.FC = () => {
  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="relative w-16 h-16">
        {/* Outer orbit */}
        <div className="absolute inset-0 rounded-full border-4 border-blue-300 animate-ping"></div>
        {/* Spinning ring */}
        <div className="absolute inset-0 rounded-full border-4 border-t-transparent border-blue-600 animate-spin"></div>
        {/* Core pulse */}
        <div className="absolute top-1/2 left-1/2 h-6 w-6 -translate-x-1/2 -translate-y-1/2 rounded-full bg-blue-500 animate-pulse"></div>
      </div>
      <span className="ml-4 text-blue-600 font-semibold tracking-wide animate-pulse">
        Loading...
      </span>
    </div>
  );
};

export default Loading;
